export default {
  duplicateQueueTime: "مدت زمان ثبت نشدن نوبت تکراری هر بیمار",
};
